(function (window) {
  'use strict';

  const input = document.querySelector('[data-filter-input]');
  const options = Array.from(document.querySelectorAll('[data-filter-option]'));
  const candidates = Array.from(document.querySelectorAll('[data-filter-item]'));
  const groups = Array.from(document.querySelectorAll('[data-filter-group]'));
  const container = document.querySelector('[data-filter-items-container]');
  let noResults;

  if (input) {
    window.filtering_i18n = window.filtering_i18n || {};
    window.filtering_i18n.no_results = 'There are no results for your search';

    input.addEventListener('keydown', debounce(function (event) {
      filterResults(this.value);
    }, 250));

    options.forEach(function (option) {
      option.addEventListener('change', function (event) {
        filterResults(input.value);
        if (typeof componentEvents !== 'undefined') {
          componentEvents.emitEvent('filtering-options-changed', [{
            options: options,
            changed: this,
          }]);
        }
      });
    });

    // Filter results on load, in case there are options checked or a
    // pre-populated search field.
    options.forEach(function (option) {
      window.triggerNativeEvent(option, 'change');
    });

    if (typeof componentEvents !== 'undefined') {
      componentEvents.on('search-standalone-cleared', function (data) {
        // If the event was fired for our input, filter results accordingly.
        if (data.searchInput === input) {
          filterResults(input.value);
        }
      });
    }

    // Create a “no results” placeholder element.
    const lastElement = groups.length ? groups[groups.length - 1] : candidates[candidates.length - 1];
    // Determine placeholder element tag according to parent element tag.
    switch (lastElement.parentNode.tagName) {
      case 'OL':
      case 'UL':
        noResults = document.createElement('li');
        break;
      default:
        noResults = document.createElement('p');
        break;
    }
    noResults.setAttribute('data-filter-no-results', '');
    // Set data attribute to skip item when sorting.
    noResults.setAttribute('data-sortable-item', '');
    noResults.setAttribute('data-sortable-item-skip', true);
    // Set a class to circumvent p:not([class]) CSS rule.
    noResults.classList.add('filter-no-results');
    noResults.innerText = window.filtering_i18n.no_results;

    // Add the “no results” placeholder after the last candidate.
    lastElement.insertAdjacentElement('afterend', noResults);

    // Mark the document body to indicate functionality is ready.
    document.body.setAttribute('data-filter-ready', '');
  }

  /**
   * Update the visibility of all candidates according to whether they match
   * the query.
   */
  function filterResults (query) {
    // Set visibility of each candidate depending on whether they match the
    // desired criteria.
    candidates.forEach(function (candidate) {
      candidate.setAttribute('aria-hidden', !matchesCriteria(candidate, query));
    });

    // Indicate whether groups are showing “empty” or not.
    groups.forEach(function (group) {
      const groupIsEmpty = !group.querySelector('[data-filter-item]:not([aria-hidden="true"])');
      group.setAttribute('data-filter-group-empty', groupIsEmpty);
    });

    // If the container exists, mark filtered/unfiltered according to
    // truthiness of query.
    if (container) {
      container.setAttribute('data-filter-filtered', !!query);
    }
  };

  /**
   * Determine whether a candidate matches the current filtering criteria.
   */
  function matchesCriteria(candidate, query) {
    // Whether the candidate’s data-filter-item value matches the query.
    const matchesQuery = candidate.dataset.filterItem.toLowerCase()
      .includes(query.toLowerCase());

    // Whether the candidate’d data-filter-option-* attributes match all
    // checked options’ values.
    const matchesOptions = options.every(function (option) {
      // Either the option is unchecked and doesn’t count, or it is checked and
      // the candidate has a data attribute to match.
      return (
        !option.checked ||
        candidate.hasAttribute('data-filter-option-' + option.value)
      );
    });

    // Return whether both conditions are met.
    return matchesQuery && matchesOptions;
  }
})(this);
